export default __webpack_public_path__ + "static/media/WM0400.34I-43894_-26191_15.9170aa95.jpg";